module.exports = __webpack_public_path__ + "img/values_animated.644c1e48.svg";